export enum UserPermissions {
  MANAGE_FARM = 'global.manage_farm',
}
